import IconClose from '@assets/icons/close.svg?react';
import { IconButton, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CloseButton = ({ closeDialog }: { closeDialog: () => void }) => {
 const { t } = useTranslation();
 const th = useTheme();
 return (
  <IconButton
   title={t('global.close')}
   aria-label={t('global.close')}
   onClick={closeDialog}
   sx={() => ({
    position: 'absolute',
    right: 8,
    top: 8,
   })}
  >
   <IconClose
    style={{ width: 20, height: 20, color: th.palette.kemek.darkestGray }}
   />
  </IconButton>
 );
};

export default CloseButton;
